// src/hooks/termOfPayments/useCreateTermOfPayment.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createTermOfPayment } from "../../api/apiTermOfPayments";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateTermOfPayment = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createTermOfPayments, isPending } = useMutation({
        mutationFn: createTermOfPayment,
        onSuccess: (res) => {
            const message = res?.message || "Term of payment created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["termOfPayments"] });
            navigate("/term-of-payments");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create term of payment");
        },
    });

    return { createTermOfPayments, isPending };
};

export default useCreateTermOfPayment;